// @flow

import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Tabs } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import messages from './messages';
import { TAB } from './constants';
import type { ManageGrossRentsTabsProps } from './types';

const ManageGrossRentsTabs = ({
  selectedTab,
  onChange,
}: ManageGrossRentsTabsProps) => {
  const tabs = useMemo(
    () => [
      {
        label: <FormattedMessage {...messages.grossRentChanges} />,
        value: TAB.GROSS_RENT_CHANGES,
      },
      {
        label: <FormattedMessage {...messages.grossRentCertifications} />,
        value: TAB.GROSS_RENT_CERTIFICATIONS,
      },
    ],
    [],
  );

  return (
    <Tabs
      onChange={onChange}
      value={selectedTab}
      tabs={tabs}
      sx={{
        borderBottomWidth: 'thin',
        borderBottomStyle: 'solid',
        borderColor: 'divider',
      }}
    />
  );
};

export default ManageGrossRentsTabs;
